module.exports = __webpack_public_path__ + "img/3_h_uk.ba070217.svg";